import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	Skeleton,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@dune/ui";
import React from "react";

const PlaceholdersTabSkeleton: React.FC = () => {
	return (
		<div className="space-y-6">
			{/* Static tags skeleton */}
			<Card className="mb-6">
				<CardHeader>
					<CardTitle className="text-lg font-semibold">
						<Skeleton className="h-6 w-32" />
					</CardTitle>
					<Skeleton className="h-4 w-96" />
				</CardHeader>
				<CardContent>
					<Table>
						<TableHeader>
							<TableRow>
								<TableHead>
									<Skeleton className="h-4 w-16" />
								</TableHead>
								<TableHead>
									<Skeleton className="h-4 w-16" />
								</TableHead>
								<TableHead>
									<Skeleton className="h-4 w-24" />
								</TableHead>
								<TableHead className="w-16">
									<Skeleton className="h-4 w-12" />
								</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{["static-tags-1", "static-tags-2", "static-tags-3"].map(
								(key) => (
									<TableRow key={key}>
										<TableCell>
											<Skeleton className="h-4 w-24" />
										</TableCell>
										<TableCell>
											<Skeleton className="h-4 w-32" />
										</TableCell>
										<TableCell>
											<Skeleton className="h-4 w-20" />
										</TableCell>
										<TableCell>
											<Skeleton className="h-8 w-8" />
										</TableCell>
									</TableRow>
								),
							)}
						</TableBody>
					</Table>
				</CardContent>
			</Card>

			{/* Parameterized tags skeleton */}
			<Card className="mb-6">
				<CardHeader>
					<CardTitle className="text-lg font-semibold">
						<Skeleton className="h-6 w-40" />
					</CardTitle>
					<Skeleton className="h-4 w-80" />
				</CardHeader>
				<CardContent>
					<Table>
						<TableHeader>
							<TableRow>
								<TableHead>
									<Skeleton className="h-4 w-16" />
								</TableHead>
								<TableHead>
									<Skeleton className="h-4 w-16" />
								</TableHead>
								<TableHead>
									<Skeleton className="h-4 w-24" />
								</TableHead>
								<TableHead className="w-16">
									<Skeleton className="h-4 w-12" />
								</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{["param-tags-1", "param-tags-2"].map((key) => (
								<TableRow key={key}>
									<TableCell>
										<Skeleton className="h-4 w-28" />
									</TableCell>
									<TableCell>
										<Skeleton className="h-4 w-36" />
									</TableCell>
									<TableCell>
										<Skeleton className="h-4 w-48" />
									</TableCell>
									<TableCell>
										<Skeleton className="h-8 w-8" />
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</CardContent>
			</Card>

			{/* Entity fields skeleton */}
			<Card>
				<CardHeader>
					<CardTitle className="text-lg font-semibold">
						<Skeleton className="h-6 w-36" />
					</CardTitle>
					<Skeleton className="h-4 w-72" />

					{/* Quick navigation skeleton */}
					<div className="mt-4 p-4 bg-gray-50 rounded-lg">
						<Skeleton className="h-4 w-32 mb-2" />
						<div className="flex flex-wrap gap-2">
							{["nav-1", "nav-2", "nav-3", "nav-4", "nav-5", "nav-6"].map(
								(key) => (
									<Skeleton key={key} className="h-8 w-20" />
								),
							)}
						</div>
					</div>
				</CardHeader>
				<CardContent className="space-y-8">
					{/* Multiple entity tables skeleton */}
					{["entity-1", "entity-2", "entity-3"].map(
						(entityKey, entityIndex) => (
							<div key={entityKey}>
								<div className="mb-4 pb-2 border-b border-gray-200">
									<Skeleton className="h-6 w-24 mb-1" />
									<Skeleton className="h-4 w-64" />
								</div>
								<Table>
									<TableHeader>
										<TableRow>
											<TableHead>
												<Skeleton className="h-4 w-16" />
											</TableHead>
											<TableHead>
												<Skeleton className="h-4 w-16" />
											</TableHead>
											<TableHead>
												<Skeleton className="h-4 w-12" />
											</TableHead>
											<TableHead className="w-16">
												<Skeleton className="h-4 w-12" />
											</TableHead>
										</TableRow>
									</TableHeader>
									<TableBody>
										{(() => {
											const rowCount = 4 + entityIndex;
											const rows = [];
											for (let i = 0; i < rowCount; i++) {
												rows.push(`${entityKey}-row-${i}`);
											}
											return rows;
										})().map((rowKey) => (
											<TableRow key={rowKey}>
												<TableCell>
													<Skeleton className="h-4 w-20" />
												</TableCell>
												<TableCell>
													<Skeleton className="h-4 w-32" />
												</TableCell>
												<TableCell>
													<Skeleton className="h-6 w-16" />
												</TableCell>
												<TableCell>
													<Skeleton className="h-8 w-8" />
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</div>
						),
					)}
				</CardContent>
			</Card>
		</div>
	);
};

export default PlaceholdersTabSkeleton;
